import { render, staticRenderFns } from "./FuelCoco.vue?vue&type=template&id=6f04daad"
import script from "./FuelCoco.vue?vue&type=script&lang=js"
export * from "./FuelCoco.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports